import { render } from "./Delete.vue?vue&type=template&id=49f5b828"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=49f5b828&lang=scss"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__